import { render } from "./CalendarEventModal.vue?vue&type=template&id=bcd6e49e&scoped=true"
import script from "./CalendarEventModal.vue?vue&type=script&lang=js"
export * from "./CalendarEventModal.vue?vue&type=script&lang=js"

import "./CalendarEventModal.vue?vue&type=style&index=0&id=bcd6e49e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd6e49e"]])

export default __exports__